import { _, Obscura, Radio } from "../../vendor";

import InboomaBaseAsyncCollection from "./InboomaBaseAsyncCollection";
import Facility from "../models/Facility";

const FacilitiesProxy = Obscura.extend({
  getFilterCount() {
    return this.getFilters().length;
  },

  filterByLocation(val) {
    // @todo OR remove
  },

  //filterByFacilitySlotType (val) {
  //  return this.filterBy('resourcetype', (model) => {
  //    return (model.get('resourcetype_id') == val);
  //  });
  //},

  filterByQuery(val) {
    return this.filterBy("query", function (model) {
      return model.get("id") === parseInt(val);
    });
  },
});

export default InboomaBaseAsyncCollection.extend({
  collectionName: "facilities",
  model: Facility,
  url: "/facilities",
  proxy: FacilitiesProxy,

  _skipPagination: true,
});
